<template>
  <div class="contenedor">
    <b-row>
      <b-col xs="12" lg="12">
        <b-card class="contenedor">
          <b-tabs class="contenedor" v-model="tabIndex">
            <b-tab title="General">
              <General v-if="tabIndex === 0"></General>
            </b-tab>
            <div v-if="accion !== 'create'">
              <b-tab title="Sistemas de Clasificación">
                <SistemasClasificacion v-if="tabIndex === 1"></SistemasClasificacion>
              </b-tab>
              <b-tab title="Etiquetas">
                <Etiquetas v-if="tabIndex === 2"></Etiquetas>
              </b-tab>
            </div>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'


import General from './General.vue';
import SistemasClasificacion from './sistemasclasificacion/Main.vue';
import Etiquetas from './etiquetas/Etiquetas';


export default {
  name: 'MainProductos',
  data() {
    return {
      tabIndex: null
    }
  },
  components: {
    General,
    SistemasClasificacion,
    Etiquetas
  },
  async mounted() {
    const id_producto = this.$route.params.id_producto;

    if (id_producto === 'crear') {
      await this.setAccion('create');
    } else {
      await this.setAccion('update');

    }

    this.tabIndex = 0;

  },
  watch: {
    async tabIndex(newValue) {
      this.load(true);
      switch (newValue) {
        case 0:
          const id_empresa = this.$route.params.id_empresa;
          this.asignaEmpresa(id_empresa);
          await this.getOrdenes();
          await this.getEstados();
          await this.getTipo();
          await this.getIdioma();
          if (this.accion === 'update') {

            const id_producto = this.$route.params.id_producto;
            await this.getProducto({id_producto, id_empresa})
          }
          this.asignaEmpresa(id_empresa);
          break;
        case 1:
          // await this.traeSistemas();
          break;
        case 2:
          //ETIQUETAS
          break;
        case 3:
          await this.traeEpp();
          break;
        default:
          //this.traeGeneral();
          break;
      }
      this.load(false);
    }
  },
  computed: {
    ...mapState('productos_et', [
      'accion',
      'ordenes',
      'empresas',
      'filtroEt'
    ]),
    ...mapState('adjuntos', [
      'idiomas'
    ])
  },
  methods: {
    async traeSistemas() {
      this.loading1 = true;

      await this.getJsonSga();
      await this.getCategorias();
      await this.getSga();
      this.loading1 = false;
    },
    async traeEpp() {
      await this.getEppIcos();
    },
    ...mapActions('sga_et', [
      'getJsonSga',
      'getSga',
      'getPictogramas',
      'getFrases',
      'getCategorias'
    ]),
    ...mapActions('epps_et', [
      'getEppIcos'
    ]),
    ...mapActions('productos_et', [
      'getEstados',
      'getExisteNoExiste',
      'guardaProducto',
      'actualizaProducto',
      'getProducto',
      'getOrdenes'
    ]),
    ...mapActions('adjuntos_et', [
      'getListadoAdj'
    ]),
    ...mapMutations('productos_et', [
      'setAccion',
      'asignaEmpresa',
      'limpiarGeneral',
      'asignaEmpresa'
    ]),
    ...mapActions('adjuntos', [
      'getIdioma',
      'getTipo',
      'getEstadoFds'
    ]),
    ...mapMutations('dashboard', [
      'load'
    ]),
  }
}

</script>
